__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "globalsearch";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(249), __webpack_require__.e(914), __webpack_require__.e(158)]).then(() => (() => (__webpack_require__(4158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(831), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(1479))))));
			register("@mui/material", "0", () => (Promise.all([__webpack_require__.e(249), __webpack_require__.e(709), __webpack_require__.e(864), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(831), __webpack_require__.e(420)]).then(() => (() => (__webpack_require__(6864))))));
			register("@reduxjs/toolkit", "2.11.2", () => (__webpack_require__.e(740).then(() => (() => (__webpack_require__(8740))))));
			register("@salesforce/design-system-react", "0.10.65", () => (Promise.all([__webpack_require__.e(676), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(819)]).then(() => (() => (__webpack_require__(5676))))));
			register("i18next", "24.2.3", () => (__webpack_require__.e(526).then(() => (() => (__webpack_require__(2526))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(961))))));
			register("react-i18next", "15.7.4", () => (Promise.all([__webpack_require__.e(365), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(2365))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(135), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(5135))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(2648))))));
			register("react", "17.0.2", () => (__webpack_require__.e(543).then(() => (() => (__webpack_require__(8543))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};